import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28.438 26.25"><path className="a" d="M10.938-26.25v12.031H24.063V-26.25Zm2.188,2.188h2.188v4.375L17.5-21.875l2.188,2.188v-4.375h2.188v7.656h-8.75ZM3.281-12.031V0H16.406V-12.031Zm15.313,0V0H31.719V-12.031ZM5.469-9.844H7.656v4.375L9.844-7.656l2.188,2.188V-9.844h2.188v7.656H5.469Zm15.313,0h2.188v4.375l2.188-2.187,2.188,2.188V-9.844h2.188v7.656h-8.75Z" transform="translate(-3.281 26.25)"/></svg>
  )
